module.exports = __webpack_public_path__ + "img/link.54493c9b.svg";